import axiosClient from './axiosClient';

export interface AuditLogDto {
  id: number;
  action: string;
  resource: string | null;
  description: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  userId: number;
  createdAt: string;
}

export interface ListAuditLogsResponse {
  data: AuditLogDto[];
  total: number;
  page: number;
  limit: number;
}

export async function listAuditLogs(params?: { page?: number; limit?: number; q?: string }): Promise<ListAuditLogsResponse> {
  const { data } = await axiosClient.get('/audit-logs', { params });
  return data;
}

export async function exportAuditLogsCsv(): Promise<Blob> {
  const response = await axiosClient.get('/audit-logs/export', { responseType: 'blob' });
  return response.data as Blob;
}


